/**
 * 题干朗读：微信内优先服务端 MP3，否则浏览器语音合成。
 */
import http from '@/utils/request'

let ttsAudio = null

export function stopSpeech() {
  try {
    if (ttsAudio) {
      ttsAudio.pause()
      ttsAudio.src = ''
      ttsAudio = null
    }
  } catch (e) { /* ignore */ }
  if (hasSpeechApi()) {
    try {
      window.speechSynthesis.cancel()
    } catch (e) { /* ignore */ }
  }
}

export function hasSpeechApi() {
  return (
    typeof window !== 'undefined' &&
    'speechSynthesis' in window &&
    typeof window.SpeechSynthesisUtterance !== 'undefined'
  )
}

export function shouldShowReadButton() {
  return typeof window !== 'undefined'
}

function normalizeQuestionTitleForSpeech(text) {
  return String(text || '')
    .replace(/_{3,}/g, '，请填空，')
    .replace(/_{2,}/g, '，请填空，')
    .replace(/_/g, '')
    .replace(/（\s*）/g, '，请填空，')
    .replace(/\(\s*\)/g, '，请填空，')
    .replace(/\s+/g, '')
    .trim()
}

function speakWithBrowser(text) {
  return new Promise((resolve, reject) => {
    if (!hasSpeechApi()) {
      reject(new Error('当前环境不支持朗读'))
      return
    }
    const cleaned = normalizeQuestionTitleForSpeech(text)
    if (!cleaned) {
      reject(new Error('没有可朗读的内容'))
      return
    }
    const utter = new window.SpeechSynthesisUtterance(cleaned)
    utter.lang = 'zh-CN'
    utter.rate = 0.92
    utter.onend = () => resolve()
    utter.onerror = () => reject(new Error('朗读失败，请检查是否静音'))
    window.speechSynthesis.cancel()
    window.setTimeout(() => {
      window.speechSynthesis.speak(utter)
    }, 80)
  })
}

function playAudioUrl(url) {
  return new Promise((resolve, reject) => {
    stopSpeech()
    const audio = new Audio(url)
    ttsAudio = audio
    audio.onended = () => resolve()
    audio.onerror = () => reject(new Error('播放失败，请检查网络'))
    audio.play().catch(() => reject(new Error('无法播放，请再点一次')))
  })
}

/**
 * 朗读题干（仅标题）
 * @param {{ text?: string, questionId?: number }} payload
 */
export async function speakQuestionTitle(payload = {}) {
  const text = payload.text || ''
  const questionId = payload.questionId || 0
  try {
    const params = questionId > 0 ? { question_id: questionId } : { text }
    const res = await http.get('/api/question/tts', { params })
    if (res.data.code === 200 && res.data.data && res.data.data.audio_url) {
      await playAudioUrl(res.data.data.audio_url)
      return
    }
  } catch (e) {
    const msg = (e.response && e.response.data && e.response.data.msg) || e.message || ''
    if (msg.indexOf('未配置语音') !== -1 || msg.indexOf('百度') !== -1) {
      return speakWithBrowser(text)
    }
    if (hasSpeechApi()) {
      return speakWithBrowser(text)
    }
    throw new Error(msg || '朗读失败')
  }
  if (hasSpeechApi()) {
    return speakWithBrowser(text)
  }
  throw new Error('朗读不可用')
}

export function speakText(text) {
  return speakQuestionTitle({ text })
}
